import React from "react";
import Brochures from "../../components/brochures/Brochures";

const BrochuresPage = () => {
  return (
    <>
      <Brochures />
    </>
  );
};

export default BrochuresPage;
